import styled from 'styled-components/macro';

export const ZoomActionsWrapper = styled.div`
  display: flex;
  gap: 8px;
  height: 36px;
`;
